import propTypes from "prop-types"
import { useEffect } from "react"
import { Modal, ModalBody, ModalHeader, Alert } from "reactstrap"
import { useQuery, useMutation } from "@tanstack/react-query"

import { Loading } from "components"
import { editPrices, getPrice } from "services/productPrices"
import PricesForm from "./PricesForm"


const EditModalForm = ({ isOpen, toggle, product, priceId, registeredPrices, setShowAlertSuccess, setMsgSuccess }) => {
  const { data, error, isLoading, isError, refetch } = useQuery(["prices", priceId], () => getPrice(priceId))

  const {
    isLoading: isLoadingEdit,
    isError: isErrorEdit,
    error: errorEdit,
    isSuccess: isSuccessEdit,
    mutateAsync,
  } = useMutation(["prices", priceId], (data) => editPrices(priceId, data))

  const submit = async (data) => {
    await mutateAsync(data)
  }

  useEffect(() => {
    if (isSuccessEdit) {
      setMsgSuccess("Precio modificado satisfactoriamente")
      setShowAlertSuccess(true)
      toggle()
    }
  }, [isSuccessEdit])

  useEffect(() => {
    refetch()
  }, [isOpen])

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true} size="lg" backdrop="static">
      <ModalHeader toggle={toggle} charcode="X">
        Editar precio
      </ModalHeader>
      <ModalBody>
        {isLoading ? (
          <div className="text-center my-3">
            <Loading isLoading={isLoading} size={2} />
          </div>
        ) : isError ? (
          <div className="text-center my-3">
            <Alert color="danger">{error?.errors?.map((error) => error?.message)}</Alert>
          </div>
        ) : (
          <PricesForm
            data={data}
            submit={submit}
            toggle={toggle}
            isLoading={isLoadingEdit || isLoading}
            isError={isErrorEdit}
            error={errorEdit}
            product={product}
            registeredPrices={registeredPrices?.map((e) => ({ id: e.id, amount: e.amount, price: e.price.id }))}
          />
        )}
      </ModalBody>
    </Modal>
  )
}

EditModalForm.propTypes = {
  isOpen: propTypes.any,
  toggle: propTypes.func,
  product: propTypes.object,
  priceId: propTypes.string,
  registeredPrices: propTypes.array,
  setShowAlertSuccess: propTypes.func.isRequired,
  setMsgSuccess: propTypes.func.isRequired,
}

export default EditModalForm
